// Renderer de BLOQUES anidables (Fase 3): texto / imagen / botón / columnas.
//
// El panel del sistema guarda un arreglo de bloques; aquí se pintan de forma recursiva. Seguridad:
// el texto va por <RichText> (sanitizado con DOMPurify), los botones por safeUrl (solo http/https/
// mailto/tel/rutas internas) y las imágenes por resolveImage (acepta empaquetadas y URLs subidas).
// Las columnas se apilan en móvil y se reparten en rejilla a partir de 620px.

import React from "react";
import { Link } from "react-router-dom";
import { RichText } from "./richText.jsx";
import { resolveImage } from "./resolveImage";
import { safeUrl } from "./safeUrl";

function ButtonBlock({ block }) {
  const isBrand = (block.variant || "brand") !== "ghost";
  const cls = isBrand ? "btn-brand" : "btn-ghost";
  const text = block.text || "Ver más";
  const link = typeof block.link === "string" ? block.link.trim() : "";

  if (link.startsWith("/")) {
    return (
      <div>
        <Link to={link} className={cls}>{text}</Link>
      </div>
    );
  }
  const href = safeUrl(link);
  if (!href) {
    return (
      <div>
        <span className={cls} style={{ opacity: 0.6 }}>{text}</span>
      </div>
    );
  }
  return (
    <div>
      <a className={cls} href={href} target="_blank" rel="noopener noreferrer">{text}</a>
    </div>
  );
}

function Block({ block }) {
  if (!block || typeof block !== "object") return null;

  switch (block.type) {
    case "richText":
      return <RichText html={block.html} className="text-tPrimary leading-[28px]" />;

    case "image": {
      const src = resolveImage(block.url);
      if (!src) return null;
      return (
        <figure className="m-0">
          <img
            src={src}
            alt={block.alt || ""}
            className="w-full h-auto rounded-xl object-cover"
          />
          {block.caption ? (
            <figcaption className="text-sm text-gray-500 mt-2 text-center">{block.caption}</figcaption>
          ) : null}
        </figure>
      );
    }

    case "button":
      return <ButtonBlock block={block} />;

    case "columns": {
      const cols = Array.isArray(block.columns) ? block.columns : [];
      if (cols.length === 0) return null;
      return (
        <div className="blocks-row" style={{ "--cols": cols.length }}>
          {cols.map((col, i) => (
            <div key={i}>
              <Blocks blocks={col} />
            </div>
          ))}
        </div>
      );
    }

    default:
      return null;
  }
}

export function Blocks({ blocks }) {
  if (!Array.isArray(blocks) || blocks.length === 0) return null;
  return (
    <div className="flex flex-col gap-5">
      {blocks.map((b, i) => (
        <Block key={(b && b.id) || i} block={b} />
      ))}
    </div>
  );
}

export default Blocks;
